import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { sesionToken, usuariosAPI } from '../services/api';

// Sesión del jugador. Registrarse es opcional: mientras no haya usuario, la
// aplicación funciona igual que siempre.
const SesionContext = createContext(null);

export function SesionProvider({ children }) {
  const [usuario, setUsuario] = useState(null);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    if (!sesionToken.get()) {
      setCargando(false);
      return;
    }

    // El testigo guardado puede haber caducado: lo valida el servidor
    usuariosAPI.perfil()
      .then(respuesta => setUsuario(respuesta.data))
      .catch(() => sesionToken.clear())
      .finally(() => setCargando(false));
  }, []);

  const entrar = useCallback((token, datosUsuario) => {
    sesionToken.set(token);
    setUsuario(datosUsuario);
  }, []);

  const salir = useCallback(() => {
    sesionToken.clear();
    setUsuario(null);
  }, []);

  // Tras jugar con otro handicap, la app recuerda el nuevo
  const actualizarUsuario = useCallback((datos) => {
    setUsuario(anterior => (anterior ? { ...anterior, ...datos } : anterior));
  }, []);

  return (
    <SesionContext.Provider value={{ usuario, cargando, entrar, salir, actualizarUsuario }}>
      {children}
    </SesionContext.Provider>
  );
}

export function useSesion() {
  const contexto = useContext(SesionContext);
  if (!contexto) {
    throw new Error('useSesion debe usarse dentro de SesionProvider');
  }
  return contexto;
}
